// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import {Svg_img} from '../ui/svg_img';
import cn from 'classnames';
import styles from './reliability_banner.module.less';

const Reliability_card = ({text}: {text: string})=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.reliability_card}>
      <Svg_img id={'hola2023/icons/18/check.svg'} w={18} h={18} />
      <p className={cn([theme.p2, theme.med,
        theme.color_n700, theme.text_center])}>{text}</p>
    </div>;
};

const default_texts = ['Trusted by millions worldwide',
    'Works across browsers and devices', '190+ locations available'];

export const Reliability_banner = ()=>{
    return <div className={styles.reliability_card_container}>
        {default_texts.map((text, i)=>
          <Reliability_card key={i} text={text}/>)}
    </div>;
};

interface i_reliability_banner_editor_props {
    value: unknown;
    on_change: (value: unknown)=>void;
}

export const Reliability_banner_editor = ({value, on_change}:
i_reliability_banner_editor_props)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
